import { randNumber } from '@ngneat/falso';

import { randomArray, optional } from '@library/common/functions';
import { MockPath } from '@library/common/http/mock-path.mock';

import { Activity } from './activity';
import { MockActivity } from './activity.mock';

export const ActivityFeedRoutes: MockPath<Activity>[] = [
   { path: 'activityfeed', verb: 'GET', response: () => ({
      collection: randomArray( MockActivity, 50 ),
      isMore: optional(),
      lastId: randNumber(),
   })},
   { path: 'activityfeed/recover', verb: 'GET', collection: () => [] },
];
